import {paths} from './contains'
import Main from './Main.lazy'

export default {
  paths,
  path: [
    '/',
    // paths.newPath,
    // paths.followingPath,
    // paths.mySpacePath,
    // paths.mySpaceNewsPath,
    // paths.mySpaceDocumentsPath,
    paths.workspacePath,
    // paths.followingCategoryPath,
    paths.categoryPath,
    paths.defaultCategoryPath,
  ],
  withSubDomain: true,
  component: Main,
  // exact: true
}
